import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  // 만료 종류에 따라 제목만 달라진다 (무료체험 종료 / 멤버십 이용기간 종료)
  status: "TRIAL_EXPIRED" | "SUBSCRIPTION_EXPIRED";
}

// 아이콘 세트에 자물쇠가 없어 인라인으로 그린다(시안: 연파랑 원 안 네이비 자물쇠).
// 접근 권한 안내 패널도 같은 잠금 표현을 쓰므로 밖으로 내보낸다.
export const LockIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect
      x="5"
      y="10.5"
      width="14"
      height="9.5"
      rx="2"
      stroke="#00417D"
      strokeWidth="2"
    />
    <path
      d="M8 10V7.5C8 5.29 9.79 3.5 12 3.5C14.21 3.5 16 5.29 16 7.5V10"
      stroke="#00417D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * 멤버십 만료 잠금 패널 — 상품 찾기/담은 상품에서 체험·멤버십이 만료된 바이어에게
 * 콘텐츠 대신 보여준다(시안). 페이지 헤더는 그대로 두고 본문만 대체한다.
 */
function PathPickMembershipExpiredPanel({ status }: Props) {
  const { t } = useI18nHelper();
  const navigate = useNavigate();

  return (
    <Flex
      flex={1}
      minHeight={"420px"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={"16px"}
      padding={"32px"}
      border={"1px solid #E5E5E3"}
      borderRadius={"8px"}
      background={"#FFFFFF"}
    >
      <Flex
        boxSize={"48px"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"full"}
        background={"#E8F2FF"}
      >
        <LockIcon />
      </Flex>
      <Flex flexDirection={"column"} gap={"8px"} alignItems={"center"}>
        <Text
          textStyle={"body-lg-bold"}
          fontSize={"22px"}
          color={"#1D1D1B"}
          textAlign={"center"}
        >
          {t(
            status === "TRIAL_EXPIRED"
              ? "path_pick:membership_lock.trial_expired_title"
              : "path_pick:membership_lock.subscription_expired_title"
          )}
        </Text>
        <Text
          textStyle={"body-md-regular"}
          color={"#6F6F6C"}
          textAlign={"center"}
          maxWidth={"520px"}
        >
          {t("path_pick:membership_lock.description")}
        </Text>
      </Flex>
      <Flex gap={"8px"}>
        <AppButton
          variant={"primary"}
          onClick={() => navigate("/pathpick/membership")}
        >
          {t("path_pick:membership_lock.cta_plans")}
        </AppButton>
        <AppButton
          variant={"white"}
          onClick={() => ChannelService.showMessenger()}
        >
          {t("path_pick:membership_lock.cta_contact")}
        </AppButton>
      </Flex>
    </Flex>
  );
}

export default PathPickMembershipExpiredPanel;
